import { useIsPeopleUnlockButtonLoading } from '@aibees/elephant/components/people-unlock/hooks/use-is-people-unlock-button-loading';
import { ProfileDetailsNoData } from '@aibees/elephant/components/profile-details-no-data';
import { usePersonReadDataContext } from '@aibees/elephant/context';
import { RecommendationsItem } from '@aibees/elephant/feature/search-table-people/components/people-drawer/components/contact-details/components/recommendations/components/recommendations-item';
import { useGetRecommendationsApi } from '@aibees/elephant/feature/search-table-people/components/people-drawer/components/contact-details/components/recommendations/hooks/use-get-recommendations-api';
import { PersonContactDetailsItem } from '@aibees/elephant/feature/search-table-people/types';
import { Scrollbar } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Stack } from '@mui/material';
import { memo } from 'react';
import { ContactDetailItemHeader } from '../../../contact-detail-item-header';
import { useContactDetailsState } from '../../context';
import { useSetSeemoreVisibility } from '../../hooks/use-set-seemore-visibility';
import * as EXTERNALSX from '../../sx';
import { doesContactDetailHaveUpdate } from '../../utils';
import * as SX from './sx';
import type { RecommendationsProps as Props } from './types';

// TODO: V2: refactor this after API is ready
export const Recommendations = memo(
  ({ className, itemsLimit, setShowSeeMore }: Props) => {
    const { data: recData } = useGetRecommendationsApi();
    const { api } = usePersonReadDataContext();
    const { loadingContactDetails } = useIsPeopleUnlockButtonLoading(api.data);
    const { unlocked, isPopoverType } = useContactDetailsState();
    useSetSeemoreVisibility(
      setShowSeeMore,
      itemsLimit,
      recData?.content?.length
    );
    const hasUpdate = doesContactDetailHaveUpdate(
      PersonContactDetailsItem.RECOMMENDATION,
      api.data
    );

    const content = (
      <Stack direction="column" gap={1}>
        {hasUpdate && recData?.content?.[0] && (
          <div
            key={-1}
            style={{
              filter: 'blur(4px)',
            }}
            onClick={(e) => e.preventDefault()}
          >
            <RecommendationsItem
              key={-1}
              item={recData?.content?.[0]}
              index={-1}
            />
          </div>
        )}
        {recData?.content?.map((item, index) => {
          if (!!itemsLimit && index >= itemsLimit) return null;
          return <RecommendationsItem key={index} item={item} index={index} />;
        })}
      </Stack>
    );

    return (
      <Box className={classnames('Recommendations', className)} sx={SX.root}>
        <ContactDetailItemHeader
          title="Recommendations"
          count={recData?.content?.length ?? 0}
        />
        {!unlocked || loadingContactDetails ? (
          <ProfileDetailsNoData />
        ) : isPopoverType ? (
          <Scrollbar sx={EXTERNALSX.generalProfileDetailsScrollbar}>
            {content}
          </Scrollbar>
        ) : (
          content
        )}
      </Box>
    );
  }
);

Recommendations.displayName = 'Recommendations';
